import { ViewType } from '@this+that/models';

export const VIEW_TYPES = {
  PRIMARY: 'PRIMARY',
  PROMOTIONS: 'PROMOTIONS',
  SOCIAL: 'SOCIAL',
  UPDATES: 'UPDATES',
  FORUMS: 'FORUMS',
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  SPAM: 'SPAM',
  TRASH: 'TRASH',
  ALL_EMAILS: 'ALL_EMAILS',
} as const satisfies Record<string, ViewType>;
